module["exports"] = [
  "Astrid",
  "Anna",
  "Alice",
  "Amanda",
  "Ann",
  "Agneta",
  "Anette",
  "Anneli",
  "Alexandra",
  "Agnes",
  "Anne",
  "Alva",	
  "Alma",	
  "Angelica",	
  "Ann-Marie",
  "Maria",
  "Margareta",
  "Elisabeth",
  "Eva",
  "Birgitta",
  "Kristina",
  "Karin",
  "Elisabet",
  "Marie",
  "Lotta",
  "Ronja",
  "Veronica"
];


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/sv/name/first_name_women.js
// module id = 3595
// module chunks = 1609